import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'atl-actions-bottom-panel',
  templateUrl: './actions-bottom-panel.component.html',
  styleUrls: ['./actions-bottom-panel.component.scss'],
})
export class ActionsBottomPanelComponent {
  @Input() public selectedItems!: number;
  @Input() public customText: string[] = [];

  @Output() private readonly passCancel = new EventEmitter<boolean>();
  @Output() private readonly passDownload = new EventEmitter<boolean>();

  public isDownload = false;

  public cancel(): void {
    this.passCancel.emit(true);
  }

  public download(): void {
    this.isDownload = true;
    this.passDownload.emit(true);
  }
}
